<section class="integration-editor" aria-labelledby="integration-editor-title">
  <header class="integration-header">
    <div>
      <h2 id="integration-editor-title">Business Central</h2>
      <p class="integration-subtitle">Manage the credentials required to connect to Business Central.</p>
    </div>
  </header>

  <!-- Status Message -->
  @if (statusMessage()) {
  <div class="status-message" [class.success]="statusMessage().toLowerCase().includes('success')" [class.error]="statusMessage().toLowerCase().includes('error') || statusMessage().toLowerCase().includes('invalid') || statusMessage().toLowerCase().includes('failed')">
    {{ statusMessage() }}
  </div>
  }
  @if (errorMessage()) {
  <div class="status-message error">
    {{ errorMessage() }}
  </div>
  }

  <!-- Loading State -->
  @if (isLoading()) {
  <div class="loading-state">
    <div class="spinner"></div>
    <p>Loading Business Central configuration...</p>
  </div>
  } @else {
  <!-- Identity Configuration Form -->
  <form class="integration-form" [formGroup]="integrationForm" (ngSubmit)="saveConfiguration()" novalidate>
    <!-- Connection Settings -->
    <div class="form-field">
      <label for="integrationBaseUrl">Business Central Base URL</label>
      <input
        id="integrationBaseUrl"
        type="text"
        placeholder="https://api.businesscentral.dynamics.com/v2.0/..."
        formControlName="integrationBaseUrl"
        [attr.aria-invalid]="integrationForm.get('integrationBaseUrl')?.invalid"
      />
      <small>The OData API base URL of your Business Central environment (e.g., https://api.businesscentral.dynamics.com/v2.0/tenant-id/environment-name). Must be HTTPS.</small>
      @if (getControlError('integrationBaseUrl'); as error) {
        <p class="field-error">{{ error }}</p>
      }
    </div>

    <div class="form-field">
      <label for="callbackEndpointPath">Callback Endpoint Path</label>
      <input
        id="callbackEndpointPath"
        type="text"
        placeholder="/ODataV4/SaaSPortalFunctions_ReceiveMessage"
        formControlName="callbackEndpointPath"
      />
      <small>Business Central callback endpoint path. Default: /ODataV4/SaaSPortalFunctions_ReceiveMessage</small>
    </div>

    <!-- Authentication Settings -->
    <div class="form-grid">
      <div class="form-field">
        <label for="azureAdTenantId">Business Central Tenant ID</label>
        <input
          id="azureAdTenantId"
          type="text"
          placeholder="A0000000-B000-C000-D000-E00000000000"
          formControlName="azureAdTenantId"
          [attr.aria-invalid]="integrationForm.get('azureAdTenantId')?.invalid"
        />
        <small>Azure AD Directory (tenant) ID for Business Central authentication.</small>
        @if (getControlError('azureAdTenantId'); as error) {
          <p class="field-error">{{ error }}</p>
        }
      </div>

      <div class="form-field">
        <label for="clientId">Client ID</label>
        <input
          id="clientId"
          type="text"
          placeholder="A0000000-B000-C000-D000-E00000000000"
          formControlName="clientId"
          [attr.aria-invalid]="integrationForm.get('clientId')?.invalid"
        />
        <small>Azure AD Application (client) ID for Business Central authentication.</small>
        @if (getControlError('clientId'); as error) {
          <p class="field-error">{{ error }}</p>
        }
      </div>
    </div>

    <div class="form-field">
      <label for="clientSecret">Client Secret</label>
      <input
        id="clientSecret"
        type="password"
        autocomplete="off"
        formControlName="clientSecret"
        [placeholder]="hasClientSecret() ? '•••••••• (Configured)' : 'Enter client secret'"
      />
      <small>Azure AD client secret for Business Central authentication. Leave empty to keep existing.</small>
    </div>

    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="reloadConfiguration()" [disabled]="isLoading() || isSaving()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="integrationForm.invalid || isSaving()">
        {{ isSaving() ? 'Saving…' : 'Save' }}
      </button>
    </div>
  </form>
  }
</section>
